var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"inset":"","dense":"","hide-details":"","readonly":_vm.readonly,"color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.clickThis.apply(null, arguments)}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }